<template>
  <div>
    <!--offset-y-->
    <v-menu
      v-model="isOn"
      content-class="range-content"
      transition="slide-y-transition"
      outlined
      location="bottom"
      min-width="258"
    >
      <template #activator="{ props }">
        <v-text-field
          v-bind="props"
          :model-value="value"
          class="trigger select-item"
          :color="activatorColor"
          :label="label"
          :hint="hint"
          readonly
          :persistent-hint="isPersistentHint"
          :hide-details="!isPersistentHint"
        >
          <template v-slot:prepend-inner>
            <v-icon v-if="!loading" class="material-icons-outlined">
              {{ innerIcon }}
            </v-icon>
            <span v-else class="icon-spiner"></span>
          </template>
        </v-text-field>
      </template>

      <v-card elevation="4">
        <div class="px-4 py-2">
          <slot />
        </div>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
  export default {
    props: {
      innerIcon: {
        type: String,
        default: '',
      },
      hint: {
        type: String,
        default: '',
      },
      label: {
        type: String,
        default: '',
      },
      value: {
        type: String || Number,
        default: '',
      },
      loading: {
        type: Boolean,
        default: false,
      }
    },
    data() {
      return {
        isOn: false,
        isTouched: false
      };
    },
    computed: {
      isPersistentHint() {
        return !!this.hint.length
      },
      activatorColor() {
        return this.isOn ? 'primary' : 'secondary';
      },
    },
    watch: {
      userCountries(countries) {
        this.setCountries(countries);
      },
      isOn(val) {
        if (val) {
          this.isTouched = true;
        }
      }
    },
  };
</script>

<style lang="scss">
@use 'sass:map';
  @use '../assets/styles/theme' as *;

  .icon-spiner {
    width: 24px;
    height: 24px;
    border: 3px solid transparent;
    border-bottom-color: map.get($colors, primary);
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
  }

  @keyframes rotation {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(360deg);
    }
  }
</style>
